import { Component, OnInit } from "@angular/core";
import { MapHelperService } from "src/services/map-helper.service";

@Component({
  selector: "basemap-selector",
  templateUrl: "./basemap-selector.component.html",
  styleUrls: ["./basemap-selector.component.css"],
})
export class BasemapSelectorComponent implements OnInit {
  bntStyle: string = "cardbasemapSelector2";
  constructor(private _mapService: MapHelperService) {}
  bit: number = 1;
  ngOnInit(): void {}
  
  onChangeBaseMapSatellite() {
    if(this.bit == 1)
    {
    this._mapService.ShowHideBaseMapSatellite();
    this.bntStyle = "cardbasemapSelector";
    this.bit = 2;
    }else{
      this._mapService.ShowHideBaseMapSatellite();
    this.bntStyle = "cardbasemapSelector2";
    this.bit = 1;
    }
  }
}
